import { CHURCH_MEMBER_NAMES } from '../services/activityLog';

export function formatActorLabel(entry) {
  if (!entry) return 'Unknown';

  if (entry.type === 'login') {
    return entry.actorName || entry.summary || 'Sign in';
  }

  if (entry.actorName?.trim()) {
    const name = entry.actorName.trim();
    if (entry.loginRole === 'admin') return `${name} · Admin`;
    return name;
  }

  const email = entry.actorEmail?.trim().toLowerCase();
  if (!email) return 'Unknown editor';

  const name = CHURCH_MEMBER_NAMES[email] || email.split('@')[0];
  if (entry.loginRole === 'admin' || email === 'admin@psagchurch.org') {
    return `${name} · Admin`;
  }
  return name;
}

export function formatChangePreview(value) {
  if (value === undefined || value === null) return 'Default content';
  if (Array.isArray(value)) return `${value.length} item${value.length === 1 ? '' : 's'}`;
  if (typeof value === 'object') {
    try {
      const text = JSON.stringify(value, null, 2);
      return text.length > 220 ? `${text.slice(0, 220)}…` : text;
    } catch {
      return 'Structured content';
    }
  }

  const text = String(value).replace(/\s+/g, ' ').trim();
  if (!text) return '(empty)';
  return text.length > 180 ? `${text.slice(0, 180)}…` : text;
}

export function canRevertEntry(entry) {
  if (!entry || entry.reverted) return false;
  if (entry.type === 'login' || entry.type === 'reset_all') return false;
  return Boolean(entry.contentKey);
}
